import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { Star, Download } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Gracias al ebook, pude aprender todo desde cero y ya tengo mis primeros clientes.',
    name: 'María L.',
    role: 'Principiante'
  }, {
    text: 'Es súper fácil de entender y aplicar. Me dio la confianza para empezar a ofrecer servicios desde casa.',
    name: 'Sofía R.',
    role: 'Emprendedora'
  }, {
    text: 'Las estrategias de marketing son muy prácticas y me ayudaron a conseguir clientes rápido.',
    name: 'Camila T.',
    role: 'Manicurista Independiente'
  }];
  return <section className="py-24 bg-white" data-id="element-211">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <div className="text-center mb-16" data-id="element-213">
          <motion.span className="text-rose-600 font-bold tracking-wider uppercase text-sm mb-4 block" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-214">
            Prueba Social
          </motion.span>
          <SectionHeading title="Miles de personas ya empezaron a aplicar estas técnicas y generar ingresos desde casa." data-id="element-215" />

          <motion.div className="flex flex-col items-center justify-center gap-2 mt-6" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} data-id="element-216">
            <div className="flex gap-1 text-gold-500" data-id="element-217">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-218" />)}
            </div>
            <div className="flex items-center gap-2 text-dark font-bold text-lg bg-rose-50 px-4 py-2 rounded-full mt-2" data-id="element-219">
              <Download className="w-5 h-5 text-rose-500" data-id="element-220" />
              Más de 6.500 descargas
            </div>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-221">
          {testimonials.map((testimonial, index) => <motion.div key={index} className="bg-white rounded-2xl p-8 shadow-soft border border-rose-100 relative" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} data-id="element-222">
              <div className="text-gold-400 mb-4 flex" data-id="element-223">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-224" />)}
              </div>
              <p className="text-dark-light italic mb-6 text-lg" data-id="element-225">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-226">
                <div className="w-10 h-10 rounded-full bg-rose-200 flex items-center justify-center text-rose-700 font-bold font-playfair" data-id="element-227">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-228">
                  <p className="font-bold text-dark" data-id="element-229">{testimonial.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-230">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}